// Import react elements
import React, { useState, useEffect } from "react";

// Import hooks
import { usePersistentFilters } from "global/hooks/usePersistentFilters";

// Import components
import CustomisableTable from "global/components/CustomisableTable";
import CreateToggleFilters from "global/components/CreateToggleFilters";




const PayoutsTable = ({ initialTableColumns, payoutsData, loadingPayouts, uniqueFilterOptions, defaultFilters, handleRowSingleClick }) => {
  

    // Set filters state - needs passing to filters component and table component
    const [filters, setFilters] = useState({});

    // State needed for row selection
    const [selectedRows, setSelectedRows] = useState([]);

    // Your filter keys you want to persist
    const filterKeys = ["payoutMethod", "payoutStatus"];

    // This object maps internal filter keys to user-friendly labels
    const filterLabels = {
        method: "Method",
        status: "Status",
    };

    // Extract form-related state and functions from the `usePersistentFilters` custom hook
    const {
        selectedFilters,
        toggleFilterValue,
        setFilterGroupAllOn,
        setFilterGroupAllOff,
        resetFilterGroup
    } = usePersistentFilters("payoutsTable", filterKeys, defaultFilters);


    useEffect(() => {

        setFilters((prev) => ({
            ...prev,
            ...selectedFilters,
        }));

    }, [selectedFilters]);


    // Handle single click on a payout row
    const handleSelectPayout = (rowid) => {

        if (handleRowSingleClick) handleRowSingleClick(rowid);

    };


    return (

        <div style={{ overflowX: "auto", minWidth: "100%" }}>

            <div className="options_banner">

                <div className="date_range_picker"></div>

            </div>

            <div className="left_checkbox_filters_div">

                <CreateToggleFilters
                    uniqueFilterOptions={uniqueFilterOptions}
                    selectedFilters={selectedFilters}
                    defaultFilters={defaultFilters}
                    filterLabels={filterLabels}
                    toggleFilterValue={toggleFilterValue}
                    setFilterGroupAllOn={setFilterGroupAllOn}
                    setFilterGroupAllOff={setFilterGroupAllOff}
                    resetFilterGroup={resetFilterGroup}
                    setSelectedRows={setSelectedRows}
                />

            </div>

            <div className="right_table_div">

                <CustomisableTable
                    tableData={payoutsData}
                    initialTableColumns={initialTableColumns}
                    loadingData={loadingPayouts}
                    handleSelectRow={handleSelectPayout}
                    handleRowSingleClick={handleSelectPayout}
                    filterKeys={filterKeys}
                    filters={filters}
                    setFilters={setFilters}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                />

            </div>
           
        </div>

    )

};

export default PayoutsTable;